module.exports = __webpack_public_path__ + "static/img/phone-tax.63f47cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/phone-tax.png
// module id = T9B0
// module chunks = 1